import { useMutation, useQuery } from '@apollo/client';
import {
  IdentityVerificationCaseV1ActivityLogInput,
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1FieldsFragment,
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryDocument,
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationDocument
} from '../../../../../../generated';
import { ActivityLog } from './activity-log';
import { message } from 'antd';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';

export interface ActivityLogContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const ActivityLogContainer: React.FC<ActivityLogContainerProps> = (props) => {
  const {
    data: activityLogData,
    loading: activityLogLoading,
    error: activityLogError
  } = useQuery(StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryDocument, {
    variables: {
      identityVerificationCaseV1Id: props.caseId
    }
  });

  const [activityLogAddUpdateActivity] = useMutation(StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationDocument);

  const handleAddUpdateActivity = async (values: IdentityVerificationCaseV1ActivityLogInput) => {
    try {
      const { data } = await activityLogAddUpdateActivity({
        variables: {
          input: {
            id: props.caseId,
            activityLog: [...(activityLogData?.identityVerificationCaseV1?.activityLog?.map((a) => ({ id: a?.id })) ?? []), values]
          }
        }
      });
      if (data?.identityVerificationCaseV1Update?.status?.success) {
        message.success('Activity added successfully');
      } else {
        message.error(`Error adding activity : ${data?.identityVerificationCaseV1Update?.status?.errorMessage}`);
      }
    } catch (error) {
      message.error(`Error adding activity : ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={activityLogLoading}
      error={activityLogError}
      hasData={activityLogData}
      hasDataComponent={
        <ActivityLog
          data={activityLogData?.identityVerificationCaseV1 as StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1FieldsFragment}
          onAddUpdateActivity={handleAddUpdateActivity}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }
    />
  );
};
